export default function SatisfactionSection() {
  return (
    <section className="py-12 sm:py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
            <i className="ri-medal-line text-3xl sm:text-4xl text-[#0D2B4E]" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Waren Sie zufrieden?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-3 sm:mb-4 leading-relaxed px-4">
            Ihre Meinung ist uns wichtig! Helfen Sie anderen Kunden, uns zu finden – hinterlassen
            Sie eine Bewertung auf TrustLocal.
          </p>

          <div className="flex justify-center gap-0.5 sm:gap-1 mb-6 sm:mb-8">
            {[1, 2, 3, 4, 5].map((i) => (
              <i key={i} className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl" />
            ))}
          </div>

          <div className="bg-white rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
              <div className="text-center p-3 sm:p-4 rounded-xl bg-gray-50">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-star-fill text-2xl sm:text-3xl text-yellow-400" />
                </div>
                <p className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">9,8</p>
                <p className="text-xs sm:text-sm text-gray-600">Bewertungsdurchschnitt</p>
              </div>
              <div className="text-center p-3 sm:p-4 rounded-xl bg-gray-50">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-group-line text-2xl sm:text-3xl text-[#0D2B4E]" />
                </div>
                <p className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">5,4 Mio.</p>
                <p className="text-xs sm:text-sm text-gray-600">TrustLocal-Nutzer</p>
              </div>
              <div className="text-center p-3 sm:p-4 rounded-xl bg-gray-50">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-thumb-up-line text-2xl sm:text-3xl text-green-500" />
                </div>
                <p className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">98%</p>
                <p className="text-xs sm:text-sm text-gray-600">Weiterempfehlungsrate</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-4 sm:mb-6">
              <div className="flex items-center gap-1 bg-[#0D2B4E]/5 rounded-full px-3 sm:px-4 py-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#0D2B4E] text-base sm:text-lg" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-[#0D2B4E]">
                  Top Preis-Leistungsverhältnis
                </span>
              </div>
              <div className="flex items-center gap-1 bg-green-50 rounded-full px-3 sm:px-4 py-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-flashlight-line text-green-600 text-base sm:text-lg" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-green-700">
                  Reagiert schnell
                </span>
              </div>
            </div>

            <a
              href="https://trustlocal.de/r/6d29206952"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#0D2B4E] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-xl text-base sm:text-lg font-semibold hover:bg-[#0a2240] transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-edit-line text-xl sm:text-2xl" />
              </div>
              <span>Jetzt bei TrustLocal bewerten</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-external-link-line text-lg sm:text-xl" />
              </div>
            </a>
            <p className="text-xs sm:text-sm text-gray-400 mt-3 sm:mt-4">
              Dauert nur 1 Minute – vielen Dank für Ihr Vertrauen!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
